import { connect } from 'react-redux';
import { get } from 'lodash';
import { createSelector } from 'reselect';
import nocSharingSelector from '@store/noc/sharing/selectors';
import { changeFilterContainerVisibility } from '@store/filterContainer/actions';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { filterIndicesSelector } from '@store/comparison/selectors';
import nocSelector from '@store/noc/selectors';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import * as sharingActions from '@store/noc/sharing/actions';
import sharing from '../common/sharing';
import NocComponent from './NocComponent';

const nocPageSelector = createSelector(
  nocSharingSelector,
  nocSelector,
  filterContainerSelector,
  filterIndicesSelector,
  tabsStoreSelector,
  (store, nocStore, filterContainer, filterIndices, tabsStore) => ({
    isFetching: get(store, 'isFetching', false),
    isSharing: true,
    nocStore,
    filterContainer,
    filterIndices,
    tabs: tabsStore,
  }),
);

const NocSharing = connect(nocPageSelector, {
  init: sharingActions.initRequest,
  getSharing: sharingActions.getSharing,
  changeFilterContainerVisibility,
})(sharing()(NocComponent));

export default NocSharing;
